import React from "react";

export const DashboardSectionCard = ({
  title,
  subtitle,  
  filters,
  children,
  className = "",
}) => (
  <section className={`pd-section ${className}`.trim()}>
    {title ? <h6 className="pd-section-title">{title}</h6> : null}
    {subtitle ? <div className="pd-section-subtitle">{subtitle}</div> : null}
    {filters}
    {children}
  </section>
);

export default DashboardSectionCard;
